var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"localidades container",class:{ loading: _vm.loading }},[_c('custom-select',{attrs:{"label":"Localidad","value":_vm.value,"name":"localidad","items":_vm.localidades},on:{"input":_vm.onChange,"focus":function($event){return _vm.$emit('focus')}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }